import { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { CpaBankIntegration } from './elements/cpaBankIntegration/CpaBankIntegration'
import { StandardBankIntegration } from './elements/standardBankIntegration/StandardBankIntegration'

export const BankIntegration = (): ReactElement | null => {
  const { organization } = useUserOrganization()

  return organization?.isCegid ? <CpaBankIntegration /> : <StandardBankIntegration />
}
